export const createPerformanceHandler = ({ performanceLogger }) => {
  let called = false;
  return () => {
    if (!called) {
      performanceLogger.appLoaded();
      called = true;
    }
  };
};
